import React from "react";
import BtnRounded from './BtnRounded';
import OpenCalendly from './OpenCalendly'; 
function Booking() {
  return (
    <div className="flex  flex-col  lg:flex-row md:flex-row  items-center justify-around mt-12 text-center bg-customAqua100/20 py-20">
      <div className="mb-8 lg:mb-0 md:mb-0">
        <h3 className="text-2xl font-thin text-customAqua600">
          Prêt à prendre rendez-vous ?
        </h3>
        <p className="text-customAqua600 font-light mt-4">
          Contactez-nous dès maintenant pour prendre rendez-vous et bénéficier
          des meilleurs soins.
        </p>
      </div>
      <div className="max-w-72">
        <BtnRounded>
          <OpenCalendly />
        </BtnRounded>
      </div>
    </div>
  );
}

export default Booking;
